<template>
  <div>
    <v-data-table
      item-key="id"
      :headers="headers"
      :loading="loading"
      :items="items"
      :items-per-page="10"
      :footer-props="{'items-per-page-text': 'Số hồ sơ một trang'}"
      disable-sort
      :server-items-length="count"
      v-bind="this.$attrs"
      :options.sync="pagination"
    >
      <template v-slot:[`footer.page-text`]="items">
        Hồ sơ thứ {{ items.pageStart }} - {{ items.pageStop }} trên tổng {{ items.itemsLength }} hồ sơ
      </template>

      <template v-slot:[`item.code`]="{item}">
        <div class="d-flex align-center">
          <div
            v-if="!item.isWithdrawn"
            :class="{'done-indicator': item.documentStates, 'nope-indicator': !item.documentStates}"
          />
          <div>{{ item.code }}</div>
        </div>
      </template>
      <template v-slot:[`item.isWithdrawn`]="{item}">
        <v-icon v-if="item.isWithdrawn">mdi-close</v-icon>
      </template>
      <template v-slot:[`item.isDisplaced`]="{item}">
        <v-icon v-if="item.isDisplaced">mdi-close</v-icon>
      </template>
      <template v-slot:[`item.retryType`]="{item}">
        {{ Number($get(item, 'cv.retryType', 0)) > 0 ? '2' : '1' }}
      </template>
      <template v-slot:[`item.examResult`]="{item}">
        <div>
          <div>
            - Điểm Ngôn ngữ: <strong>{{ $get(item, 'cv.ltvExamResult.examLanguage', '') }}</strong>
          </div>
          <div>
            - Điểm Tư duy: <strong>{{ $get(item, 'cv.ltvExamResult.examMathMark', '') }}</strong>
          </div>
          <div>
            - Tổng điểm: <strong>{{ $get(item, 'cv.ltvExamResult.examTotal', '') }}</strong>
          </div>
        </div>
      </template>

      <template v-slot:[`item.documentStates`]="{item}">
        <div v-if="item.isClassAssigned && item.documentStates">
          <div>
            - HB: <v-icon>{{ $get(item, 'documentStates.studyDoc') ? 'mdi-check' : 'mdi-close' }}</v-icon>
          </div>
          <div>
            - KS: <v-icon>{{ $get(item, 'documentStates.birthDoc') ? 'mdi-check' : 'mdi-close' }}</v-icon>
          </div>
          <div>
            - TK: <v-icon>{{ $get(item, 'documentStates.accountDoc') ? 'mdi-check' : 'mdi-close' }}</v-icon>
          </div>
          <div>
            - UT: <v-icon>{{ $get(item, 'documentStates.giftedDoc') ? 'mdi-check' : 'mdi-close' }}</v-icon>
          </div>
        </div>
      </template>

      <template v-slot:[`item.actions`]="{item}">
        <v-btn @click="() => onAssignClass(item)" color="admin" outlined v-if="!canViewOnly && !item.isWithdrawn">
          {{ !item.assignClassTitle ? 'Xếp lớp' : 'Chuyển lớp' }}
        </v-btn>
        <v-btn
          @click="() => onConfirmDocument(item)"
          color="admin"
          outlined
          v-if="!canViewOnly && item.isClassAssigned"
          class="ml-2"
        >
          Xác nhận
        </v-btn>
        <v-btn
          @click="() => onWithdrawDocument(item)"
          color="error"
          outlined
          v-if="!canViewOnly && item.isClassAssigned && item.documentStates && !item.isWithdrawn"
          class="ml-2"
        >
          Rút
        </v-btn>
        <v-btn
          @click="() => onDisplaceAssignedClass(item)"
          color="error"
          outlined
          v-if="!canViewOnly && item.isClassAssigned && !item.documentStates && !item.isDisplaced"
          class="ml-2"
        >
          Loại
        </v-btn>
        <v-btn
          @click="() => onViewWithdrawnDetail(item)"
          color="admin"
          outlined
          v-if="!canViewOnly && item.isWithdrawn"
          class="ml-2"
        >
          Chi tiết
        </v-btn>
        <v-btn
          @click="() => onViewDisplacedDetail(item)"
          color="admin"
          outlined
          v-if="!canViewOnly && item.isDisplaced"
          class="ml-2"
        >
          Chi tiết
        </v-btn>
      </template>
    </v-data-table>
    <AssignDialog ref="ass-dialog" @onRefresh="refresh" />
    <DocDialog ref="doc-dialog" @onRefresh="refresh" />
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import moment from 'moment'
import utils from '@/plugins/utils'
import AssignDialog from './AssignDialog.vue'
import DocDialog from './DocDialog.vue'
import {get} from 'lodash'
const baseHeaders = [
  {text: 'Mã hồ sơ', value: 'code'},
  {text: 'Cơ sở', value: 'department'},
  {text: 'Tên thí sinh', value: 'cv.name'},
  {text: 'Đợt ĐK', value: 'retryType', align: 'center'},
  {text: 'Điểm KSĐGNL', value: 'examResult'},
  {text: 'Đã xếp lớp', value: 'assignedClassTitle'},
  {text: 'HSNH', value: 'documentStates'},
  {text: 'Rút HS', value: 'isWithdrawn', align: 'center'},
  {text: 'Bị loại', value: 'isDisplaced', align: 'center'},
  {text: 'Thao tác', value: 'actions', align: 'center'},
]

export default {
  components: {AssignDialog, DocDialog},
  computed: {
    ...mapGetters('assignClass', ['items', 'count', 'filterParams']),
    ...mapGetters('auth', ['user']),
    headers() {
      return baseHeaders
    },
    canViewOnly() {
      return this.user.username === 'uyenpt'
    },
  },
  data: () => ({loading: false, pagination: {}}),
  watch: {
    pagination: {
      async handler(newOptions, oldOptions) {
        if (newOptions && oldOptions) {
          await this.refresh((newOptions.page - 1) * newOptions.itemsPerPage, newOptions.itemsPerPage)
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    ...mapActions({
      fetchItems: 'assignClass/fetchItems',
      withdrawDocument: 'assignClass/withdrawDocument',
      displaceAssignedClass: 'assignClass/displaceAssignedClass',
    }),
    getBaseQuery() {
      let query = {type: 'Khối 6'}
      if (this.user.department === 'both') {
        if (!Object.keys(this.filterParams).includes('department_in'))
          query.department_in = ['Cơ sở A', 'Cơ sở 1', 'unset']
      } else query.department_in = [this.user.department, 'unset']
      return query
    },
    async refresh(_start = 0, _limit = 10) {
      this.loading = true
      await this.fetchItems({_start, _limit, ...this.getBaseQuery()})
      this.loading = false
    },
    onAssignClass(item) {
      this.$refs['ass-dialog'].openDialog(item)
    },
    onConfirmDocument(item) {
      this.$refs['doc-dialog'].openDialog(item)
    },
    onWithdrawDocument(item) {
      this.$dialog.confirm({
        title: 'Xác nhận <strong style="color:red">Rút hồ sơ</strong>',
        topContent: `Thông tin hồ sơ:<br/>- Mã hồ sơ: <strong>${item.code}</strong><br/>- Tên thí sinh: <strong>${get(
          item,
          'cv.name',
        )}</strong><br/>- Đã xếp lớp: <strong>${get(item, 'assignedClassTitle')}</strong>`,
        midContent: `Hồ sơ này sẽ <strong>bị loại khỏi</strong> danh sách xếp lớp và <strong>không thể xác nhận</strong> giấy tờ gốc trong tương lai.`,
        botContent: `Thao tác này <strong>không thể hoàn tác</strong>, bạn có chắc chắn muốn thực hiện?`,
        okText: 'Rút hồ sơ',
        okColor: 'error',
        cancelText: 'Kiểm tra lại',
        done: async () => {
          try {
            this.$loading.active = true
            await this.withdrawDocument({id: item.id})
            await this.refresh()
            this.$alert.success('Rút hồ sơ thành công')
          } catch (error) {
            this.$alert.error(error)
          } finally {
            this.$loading.active = false
          }
        },
      })
    },
    onViewWithdrawnDetail(item) {
      this.$dialog.confirm({
        title: 'Chi tiết Rút hồ sơ',
        okText: 'Đã hiểu',
        topContent: `Thông tin hồ sơ:<br/>- Mã hồ sơ: <strong>${item.code}</strong><br/>- Tên thí sinh: <strong>${get(
          item,
          'cv.name',
        )}</strong><br/>`,
        midContent: `Thông tin thao tác:<br/>- Thời điểm thực hiện: <strong>${moment(item.withdrawnAt).format(
          'DD/MM/YYYY, [lúc] HH:mm:ss',
        )}</strong><br/>- Người thực hiện: ${get(item, 'withdrawnBy.name')}`,
        hideCancel: true,
      })
    },
    onDisplaceAssignedClass(item) {
      this.$dialog.confirm({
        title: 'Xác nhận <strong style="color:red">Loại bỏ</strong>',
        topContent: `Thông tin hồ sơ:<br/>- Mã hồ sơ: <strong>${item.code}</strong><br/>- Tên thí sinh: <strong>${get(
          item,
          'cv.name',
        )}</strong><br/>- Đã xếp lớp: <strong>${get(item, 'assignedClassTitle')}</strong>`,
        midContent: `Hồ sơ này đã xếp lớp nhưng chưa nộp đầy đủ giấy tờ liên quan. Hồ sơ này sẽ <strong>bị loại khỏi</strong> danh sách xếp lớp.`,
        botContent: `Thao tác này <strong>không thể hoàn tác</strong>, bạn có chắc chắn muốn thực hiện?`,
        okText: 'Loại bỏ',
        okColor: 'error',
        cancelText: 'Kiểm tra lại',
        done: async () => {
          try {
            this.$loading.active = true
            await this.displaceAssignedClass({id: item.id})
            await this.refresh()
            this.$alert.success('Loại bỏ khỏi lớp được xếp thành công')
          } catch (error) {
            this.$alert.error(error)
          } finally {
            this.$loading.active = false
          }
        },
      })
    },
    onViewDisplacedDetail(item) {
      this.$dialog.confirm({
        title: 'Chi tiết <strong style="color:red">Loại bỏ</strong>',
        okText: 'Đã hiểu',
        topContent: `Thông tin hồ sơ:<br/>- Mã hồ sơ: <strong>${item.code}</strong><br/>- Tên thí sinh: <strong>${get(
          item,
          'cv.name',
        )}</strong><br/>`,
        midContent: `Thông tin lớp từng được xếp: <strong>${get(
          item,
          'backupAssignedClass.assignedClassTitle',
        )}</strong>`,
        botContent: `Thông tin thao tác:<br/>- Thời điểm thực hiện: <strong>${moment(item.displacedAt).format(
          'DD/MM/YYYY, [lúc] HH:mm:ss',
        )}</strong><br/>- Người thực hiện: ${get(item, 'displacedBy.name')}`,
        hideCancel: true,
      })
    },
  },
  filters: {
    getTransactionTime: transactionTime => (!transactionTime ? '' : moment(transactionTime).format('DD/MM/YYYY HH:mm')),
    getTransactionAmount: amount => utils.formatMoney(amount),
  },
}
</script>
<style scoped>
.done-indicator {
  position: relative;
  width: 10px;
  height: 10px;
  background-color: #4caf50; /* Adjust color as needed */
  border-radius: 50%;
  margin-right: 8px;
}

/* The ripple effect */
.done-indicator::after {
  content: '';
  position: absolute;
  top: -5px;
  left: -5px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #4caf50;
  animation: ripple 2s infinite;
}
.nope-indicator {
  position: relative;
  width: 10px;
  height: 10px;
  background-color: red; /* Adjust color as needed */
  border-radius: 50%;
  margin-right: 8px;
}

/* The ripple effect */
.nope-indicator::after {
  content: '';
  position: absolute;
  top: -5px;
  left: -5px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid red;
  animation: ripple 2s infinite;
}

@keyframes ripple {
  0% {
    transform: scale(0.5);
    opacity: 1;
  }
  100% {
    transform: scale(1.5);
    opacity: 0;
  }
}
</style>
